module.exports = __webpack_public_path__ + "img/Proliferation-OVCA_10X_TPCP.8ae535d5.png";